import type { AiToolStateOpen } from "@/components/miab/MIABPage";
import type { Store } from "@/common/storeUtils";
import { GaButton } from "@/components/general/GaButton";
import { getAiSuggestion } from "@newgenerated/shared/stubs";
import type { MIABQuestionMetadata } from "@newgenerated/shared/schema";
import type { GaVueComponent } from "@/common/vueUtils";
import { GaFormFieldTextArea } from "@/components/form/GaFormFieldTextArea";
import { GaAlert } from "@/components/general/GaAlert";
import type { TranslationFn } from "@utils/vue-migration/translationUtils";

async function getAiQuestions(state: Store<AiToolStateOpen>, dataId: number, setQuestions: (questions: MIABQuestionMetadata[]) => void): Promise<void> {
  state.set({ ...state.get(), status: "LOADING" });
  const result = await getAiSuggestion({ body: { dataId: dataId, userPrompt: state.get().prompt } });
  if (result.kind === "success") {
    setQuestions(result.data.questions);
    state.set({ ...state.get(), status: "IDLE", madeARequest: true });
  } else {
    state.set({ ...state.get(), status: "ERROR" });
  }
}

export function AiTool(props: { state: Store<AiToolStateOpen>; t: TranslationFn; dataId: number; setQuestions: (questions: MIABQuestionMetadata[]) => void }): GaVueComponent {
  return (
    <>
      {props.state.get().status === "ERROR" ? (
        <div class="mb-3">
          <GaAlert variant={"danger"}>{props.t("miab:edit.form.aiTool.error")}</GaAlert>
        </div>
      ) : null}
      <div class="mb-3">
        <div class="mb-2">
          <GaFormFieldTextArea value={props.state.get().prompt} onUpdateValue={props.state.sub("prompt").set} name="aiPrompt" placeholder={props.t("miab:edit.form.aiPrompt.placeholder")} />
        </div>
        <div class="d-flex justify-content-end">
          <GaButton onClick={() => getAiQuestions(props.state, props.dataId, props.setQuestions)}>
            <i class="ico-sparks-2" /> {props.state.get().madeARequest ? props.t("miab:edit.form.aiPrompt.regenerate") : props.t("miab:edit.form.aiPrompt.generate")}
          </GaButton>
        </div>
      </div>
    </>
  );
}
